var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tenant-logo"},[(_vm.logoUrl)?_c('img',{staticClass:"tenant-logo-image",attrs:{"src":_vm.logoUrl,"alt":_vm.tenantName}}):_c('div',{staticClass:"tenant-logo-default"},[_c('span',[_vm._v(_vm._s(_vm.defaultText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }